// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eNSe6","image":"Header_image__2tjyw","name":"Header_name__1vDDC","info":"Header_info__1s_Co","infoRow":"Header_infoRow__1tYE0"};